// extracted by mini-css-extract-plugin
export default {"basicOverlay":"_OIxV__basicOverlay"};